module.exports = __webpack_public_path__ + "static/media/poolpic.ecc8dbb3.png";